import { HTTPVerbs as t } from "@nextgen-web-framework/core";
const o = "comcontentstackas", r = "v2", $ = ({ slug: e }) => ({
  url: `/${o}/${r}/pages/${e}`,
  method: t.GET,
  retries: 0,
  timeout: 6e4
}), c = ({ uId: e }) => ({
  url: `/${o}/${r}/content/${e}`,
  method: t.GET,
  retries: 0,
  timeout: 6e4
}), m = ({ contentType: e, hash: i, entryId: s }) => ({
  url: `/${o}/${r}/live-preview/${e}?entriesUid=${s}&livePreviewHash=${i}`,
  method: t.GET,
  retries: 0,
  timeout: 6e4
});
export {
  r as API_VERSION,
  o as CMS_SERVICE_KEY,
  c as getContentReqObj,
  m as getLivePreviewReqObj,
  $ as getPageReqObj
};
//# sourceMappingURL=cmsEndPoints.js.map
